import { FaLightbulb, FaHandshake, FaAward, FaShieldAlt, FaUsers } from "react-icons/fa";
import Lottie from 'lottie-react';
import atomsAnimation2 from '../assets/Animation_1736003304638.json';

export default function AboutPage() {
  return (
    <>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#264790] to-[#1B3268] text-white py-20 px-6">
        <div className="container mx-auto max-w-6xl grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h1 className="text-4xl font-bold leading-snug mb-4">Smart Tools for Smarter Learning</h1>
            <p className="text-white/90 mb-6 text-lg">
              At <strong>Sva Learn</strong>, we believe education should be as intelligent as the learners who seek it. We are a next-generation digital learning platform built to empower students with smart, intuitive, and accessible tools that support academic success across disciplines. Whether you're preparing for exams, exploring a subject in-depth, or simply curious to learn more — our goal is to make learning personalized, engaging, and effective.
            </p>
            <p className="text-white/90 text-lg">
              Our mission is to democratize access to quality education through intelligent technology and curated resources — empowering learners to study <em>smarter, not harder</em>. From smart search and AI tutors to structured eLearning modules and personalized progress tracking — Sva Learn is redefining what modern education looks like.
            </p>
          </div>
          <div>
              <Lottie
                animationData={atomsAnimation2}
                loop={true}
                style={{
                  width: '75%',
                  height: '75%',
                  objectFit: 'cover',
                }}
              />
          </div>
        </div>
      </section>

      {/* What Makes Us Different */}
      <section className="bg-gray-50 py-20 px-6">
        <div className="container mx-auto max-w-5xl">
          <h2 className="text-3xl font-bold text-[#264790] text-center mb-12">🚀 What Makes Us Different?</h2>
          <div className="space-y-8 text-gray-800 text-lg">
            <div>
              <h3 className="font-semibold text-[#264790]">🤖 AI-Powered Study Assistant</h3>
              <p>Get instant help from subject-specific AI tutors trained on your actual syllabus — for doubt clearing, summaries, and concept explanations.</p>
            </div>
            <div>
              <h3 className="font-semibold text-[#264790]">📚 eLearning Modules</h3>
              <ul className="list-disc ml-6">
                <li>📖 Lesson Notes</li>
                <li>📝 Key Takeaways</li>
                <li>🃏 Flash Cards</li>
                <li>🧠 Mind Maps</li>
                <li>🎯 Quizzes</li>
                <li>🤖 AI Chatbot</li>
                <li>🎥 Video Lectures</li>
                <li>📂 Past Papers & Assignments</li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold text-[#264790]">📈 Personalized Progress</h3>
              <p>Track your learning streaks, completed chapters, and compare progress with peers.</p>
            </div>
            <div>
              <h3 className="font-semibold text-[#264790]">👨‍🏫 Who We Serve</h3>
              <ul className="list-disc ml-6">
                <li>📘 School & college students</li>
                <li>🏫 Educational institutions</li>
                <li>📚 Self-learners</li>
              </ul>
              <p className="mt-2">With dedicated tools for teachers and librarians, we also support institutions in building modern digital libraries and eLearning ecosystems.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}